exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".categories-options[data-v-750f3f28]{cursor:pointer;font-weight:700}hr[data-v-750f3f28]{margin-top:.85rem;margin-bottom:.85rem}", ""]);

// exports
